import React from 'react';
import bn from "../../../utils/bemnames";
import {generateCdnProxyImageUrl} from '../../../utils/helpers';
import {findOddsByOutcomeId, getOutLink} from '../../../utils/odds';
import {OutcomeIds} from '../../../utils/outcome';
import {getProviderImageUrl} from '../../../utils/providers';
import {baseSportsIndexDomain} from '../../../utils/request';
import {_t} from '../../../utils/translations';
import {IDeal, IOdds, IProvider, oddsFormats} from '../../../utils/types';
import ImgWithDefault from '../../ImgWithDefault';
import OutrightOddsButtonWithArrow from './OddsButtonWithArrow';
import OutrightOddsButtonWithTitle from './OutlinkButtonWithTitle';
import {useGlobalState} from "../../../contexts/GlobalState";
import Odds from "../../Standings/Odds";

const bem = bn.create('outright-odds-event-odds');

interface IProps {
  isMobile?: boolean;
  providerDeal: IDeal;
  outLinkFolder: string|null|undefined;
  provider: IProvider;
  widgetId: number;
  eventId: number,
  builderComponentId?: number;
  odds: IOdds[];
  oddsFormat: oddsFormats;
}

const EventOdds: React.FC<IProps> = ({
  provider,
  widgetId,
  eventId,
  outLinkFolder,
  odds,
  oddsFormat,
  isMobile = false,
  providerDeal = undefined,
  builderComponentId = undefined
}) => {
  const {globalState} = useGlobalState()

  return (
    <>
      {provider && <div className={`${bem.b()} ${isMobile ? bem.m('mobile') : ''}`}>
        <div className={bem.e('column')}>
          <div className={bem.e('label')}/>
          <div className={bem.e('provider-logo')}>
            <ImgWithDefault
              alt={provider.name}
              src={provider.squareLogoUrl ? generateCdnProxyImageUrl(`${baseSportsIndexDomain}${provider.squareLogoUrl}`) : getProviderImageUrl(provider, 'square')}
            />
          </div>
        </div>
        {providerDeal && <div className={bem.e('column')}>
          <div className={bem.e('label')}/>
          <OutrightOddsButtonWithTitle
            isMobile={isMobile}
            title={providerDeal.dealText}
            url={getOutLink(outLinkFolder, provider.slug, widgetId, eventId, builderComponentId)}
            providerId={providerDeal.providerId}
          />
        </div>}
        {findOddsByOutcomeId(odds, OutcomeIds.OUTCOME_1, globalState.promotedProvider) !== null ? (
          <div className={bem.e('column')}>
            <div className={bem.e('label')}>{_t('Home')}</div>
            <OutrightOddsButtonWithArrow
              isMobile={isMobile}
              odds={findOddsByOutcomeId(odds, OutcomeIds.OUTCOME_1, globalState.promotedProvider)}
              provider={provider}
              oddsFormat={oddsFormat}
              outLinkPath={outLinkFolder}
              widgetId={widgetId}
              builderComponentId={builderComponentId}
            />
          </div>
        ) : globalState.promotedProvider !== null && (
          <div className={bem.e('column')}>
            <div className={bem.e('label')}>{_t('Home')}</div>
            <Odds odds={null}
                  direction={null}
                  arrow={false}
                  provider={globalState.promotedProvider.provider}/>
          </div>
        )}
        {findOddsByOutcomeId(odds, OutcomeIds.OUTCOME_X, globalState.promotedProvider) !== null ? (
          <div className={bem.e('column')}>
            <div className={bem.e('label')}>{_t('Draw')}</div>
            <OutrightOddsButtonWithArrow
              isMobile={isMobile}
              odds={findOddsByOutcomeId(odds, OutcomeIds.OUTCOME_X, globalState.promotedProvider)}
              provider={provider}
              oddsFormat={oddsFormat}
              outLinkPath={outLinkFolder}
              widgetId={widgetId}
              builderComponentId={builderComponentId}
            />
          </div>
        ) : globalState.promotedProvider !== null && (
          <div className={bem.e('column')}>
            <div className={bem.e('label')}>{_t('Draw')}</div>
            <Odds odds={null}
                  direction={null}
                  arrow={false}
                  provider={globalState.promotedProvider.provider}/>
          </div>
        )}
        {findOddsByOutcomeId(odds, OutcomeIds.OUTCOME_2, globalState.promotedProvider) !== null ? (
          <div className={bem.e('column')}>
            <div className={bem.e('label')}>{_t('Away')}</div>
            <OutrightOddsButtonWithArrow
              isMobile={isMobile}
              odds={findOddsByOutcomeId(odds, OutcomeIds.OUTCOME_2, globalState.promotedProvider)}
              provider={provider}
              oddsFormat={oddsFormat}
              outLinkPath={outLinkFolder}
              widgetId={widgetId}
              builderComponentId={builderComponentId}
            />
          </div>
        ) : globalState.promotedProvider !== null && (
          <div className={bem.e('column')}>
            <div className={bem.e('label')}>{_t('Away')}</div>
            <Odds odds={null}
                  direction={null}
                  arrow={false}
                  provider={globalState.promotedProvider.provider}/>
          </div>
        )}
      </div>}
    </>
  )
}

export default EventOdds;
